import * as React from 'react';
import * as cx from 'classnames';

import { withIntl, IntlProps } from 'ha/i18n';
import { H2 } from 'ha/ui/Headers';
import MediaQuery from 'ha/helpers/MediaQuery';
import ProcessIndicator from 'ha/ui/ProcessIndicator';

const Steps: React.SFC<IntlProps> = ({ intl: { T } }) => (
  <MediaQuery>
    {({ md }) => (
      <div
        className={cx(
          'container-grid flexbox flex-align-center flex-direction__column',
          md ? 'm-t-8' : 'm-t-5',
        )}
      >
        <H2 className={cx('m-b-5 color-black', { 'font-size-xl': md })}>
          {T('Just 3 easy steps')}
        </H2>
        <div
          className={
            md
              ? 'supply-landing-steps--horizontal'
              : 'supply-landing-steps--vertical m-b-5'
          }
        >
          <ProcessIndicator
            lineClassName={cx('back-dark-orange', {
              'supply-landing-steps__line--vertical': !md,
            })}
            align={md ? 'horizontal' : 'vertical'}
          >
            {[
              {
                title: T('List your properties'),
                text: T(
                  'Create your listings within 5 minutes and make your properties visible to the world!',
                ),
              },
              {
                title: T('Select your tenants'),
                text: T(
                  'Choose your favorite tenants, make contact and confirm booking details.',
                ),
              },
              {
                title: T('Receive your payments'),
                text: T(
                  'We transfer your payment to you after your tenant has successfully moved-in.',
                ),
              },
            ].map((item, index) => (
              <ProcessIndicator.Item
                iconClassName="back-dark-orange color-white border-none"
                titleClassName={cx(
                  md
                    ? 'supply-landing-steps__title--horizontal m-t-0_7'
                    : 'top-0 transform-initial m-t-0_2 text-left supply-landing-steps__title--vertical',
                )}
                titlePosition={md ? 'bottom' : 'right'}
                key={item.title}
                title={
                  <React.Fragment>
                    <h3 className="m-b-1 color-black">{item.title}</h3>
                    <div className="line-height-big">{item.text}</div>
                  </React.Fragment>
                }
              >
                {index + 1}
              </ProcessIndicator.Item>
            ))}
          </ProcessIndicator>
        </div>
        {md && (
          <div className="line line--thin back-grey supply-landing-steps__block-line" />
        )}
      </div>
    )}
  </MediaQuery>
);

export default withIntl(Steps);
